import { useEffect } from "react";
import { scrollToPageTop } from "@/components/HelioLogoMark";
import PowloFooter from "@/components/powlo/PowloFooter";
import PowloHeader from "@/components/powlo/PowloHeader";

interface LegalLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export default function LegalLayout({ title, subtitle, children }: LegalLayoutProps) {
  useEffect(() => {
    scrollToPageTop();
  }, []);

  return (
    <div className="powlo-site min-h-screen">
      <PowloHeader />
      <main className="pb-16">
        <section className="mx-auto flex max-w-3xl flex-col gap-3 px-5 pb-4 pt-14 text-left sm:px-8">
          <h1 className="m-0 font-display text-4xl font-bold leading-tight tracking-tight text-ink sm:text-6xl">{title}</h1>
          {subtitle ? <p className="m-0 text-base text-[#4a4d55]">{subtitle}</p> : null}
        </section>
        <article className="mx-auto max-w-3xl px-5 py-4 sm:px-8">{children}</article>
      </main>
      <PowloFooter />
    </div>
  );
}
